const assetMap = {
    style: (props) => (<style {...props.attrs}>{props.children}</style>),
    link: (props) => <link {...props.attrs}/>,
    script: (props) => {
        return props.attrs.src ? (<script {...props.attrs} id={props.key}>
        {" "}
      </script>) : null;
    },
    noscript: (props) => (<noscript {...props.attrs}>{props.children}</noscript>),
};
export function renderAsset(asset, nonce) {
    let { tag, attrs: { key, ...attrs } = { key: undefined }, children } = asset;
    return assetMap[tag]({ attrs: { ...attrs, nonce }, key, children });
}
